export default __webpack_public_path__ + "static/media/img-sustainability.f3844613.jpg";